module.exports = __webpack_public_path__ + "img/rdw-1.70c29efc.jpg";